import React, {
  useRef,
  useState,
} from 'react';
import {
  useStripe,
  CardElement,
} from '@stripe/react-stripe-js';

import {
  Button,
} from 'web-components';

import * as S from './styled';

const createOptions = () => ({
  style: {
    base: {
      fontSize: '16px',
      color: '#424770',
      fontFamily: 'Open Sans, sans-serif',
      letterSpacing: '0.025em',
      '::placeholder': {
        color: '#aab7c4',
      },
    },
    invalid: {
      color: '#c23d4b',
    },
  },
});

interface Props {
  clientSecret: string,
  onSuccess: { (response: any): void },
}

const CardForm = ({
  clientSecret,
  onSuccess,
}: Props) => {
  const stripe = useStripe();
  const [card, setCard] = useState(null);
  const [isLoading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const isSubmittingRef = useRef(false);

  const handleChange = ({ error }: any) => {
    if (error) {
      setErrorMessage(error.message);
    }
  };

  const handleSubmit = async (evt: any) => {
    evt.preventDefault();
    if (isSubmittingRef.current) return;

    isSubmittingRef.current = true;
    setErrorMessage('');
    setLoading(true);
    try {
      if (stripe) {
        let res;
        if (clientSecret) {
          res = await stripe.confirmCardPayment(
            clientSecret,
            card,
          );
        } else {
          res = await stripe.createPaymentMethod(
            'card',
            card,
          );
        }

        console.log('CardForm response', res);
        if (res.error) {
          setErrorMessage(res.error.message);
        } else {
          onSuccess(res);
        }
      } else {
        console.log("Stripe.js hasn't loaded yet.");
      }
    } finally {
      isSubmittingRef.current = false;
      setLoading(false);
    }
  };

  return (
    <S.FormWrapper
      onSubmit={handleSubmit}
    >
      <label>
        Card details
        <CardElement
          id="el"
          onReady={el => setCard(el)}
          onChange={handleChange}
          {...createOptions()}
        />
      </label>
      <S.Error>
        {errorMessage}
      </S.Error>
      <Button
        type="submit"
        isLoading={isLoading}
        isDisabled={isLoading}
      >
        {clientSecret ? 'Pay' : 'Add'}
      </Button>
    </S.FormWrapper>
  );
};

export default CardForm;
